import { fromJS }        from 'immutable';
import jwtDecode         from 'jwt-decode';
import { handleActions } from 'redux-actions';
import { logout }        from '../actions/logout';
import { loginSuccess }  from '../actions/login';


const jwt = handleActions({

  [loginSuccess]: (state, {payload: {jwt}}) => {

    console.log(jwtDecode(jwt.token).exp * 1000);

    let data = fromJS(jwt)
      .set('payload', fromJS(jwtDecode(jwt.token)));

    // Convert iat (issued at time) to Date objects.
    data = data.setIn(['payload', 'iat'], new Date(data.getIn(['payload', 'iat']) * 1000));

    // Convert exp (expiry) to Date objects.
    data = data.setIn(['payload', 'exp'], new Date(data.getIn(['payload', 'exp']) * 1000));

    return data;

  },

  [logout]: () => {

    return null;

  }

}, null);


export default jwt;



// WEBPACK FOOTER //
// ./src/modules/auth/reducers/jwt.js